var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { SortTreeService } from './sort-tree.service';
var SortTreeComponent = /** @class */ (function (_super) {
    __extends(SortTreeComponent, _super);
    function SortTreeComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.tree = [];
        return _this;
    }
    SortTreeComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.closeAll();
    };
    SortTreeComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    SortTreeComponent.prototype.onSubscribe = function (data) {
        if (data instanceof Array) {
            this.tree = data;
        }
        this.service.init(this.componentName);
    };
    SortTreeComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    SortTreeComponent.prototype.openAll = function () {
        this.service.toggle(true);
    };
    SortTreeComponent.prototype.closeAll = function () {
        this.service.toggle(false);
    };
    SortTreeComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
    };
    SortTreeComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'sort-tree',
                    template: "<div id=\"{{ componentName }}\">\n  <div class=\"row -mb-1\">\n    <div class=\"col-sm-6\">\n      <p>{{ (msg | async)['SortTreeComponent.label.note'] }}</p>\n    </div>\n    <div class=\"col-sm-6 -txtalnright\">\n      <a href=\"javascript:void(0);\" (click)=\"openAll()\">{{ (msg | async)['SortTreeComponent.label.openAll'] }}</a>\n      <a href=\"javascript:void(0);\" (click)=\"closeAll()\">{{ (msg | async)['SortTreeComponent.label.closeAll'] }}</a>\n    </div>\n  </div>\n  <div class=\"tableWrapper stageFlowPane_border -p-2\" style=\"max-height: 510px;\">\n    <sort-treegroup *ngIf=\"tree?.length > 0\" [tree]=\"tree\" [name]=\"componentName + '_0'\" [parent]=\"0\" [open]=\"true\"></sort-treegroup>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    SortTreeComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: SortTreeService }
    ]; };
    return SortTreeComponent;
}(ContentBaseComponent));
export { SortTreeComponent };
var SortTreeGroupComponent = /** @class */ (function () {
    function SortTreeGroupComponent(service) {
        this.service = service;
        this.tree = [];
        this.open = false;
        this.toggle = {};
    }
    SortTreeGroupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subsc = this.service.observable.subscribe(function (flg) {
            for (var _i = 0, _a = _this.tree; _i < _a.length; _i++) {
                var t = _a[_i];
                _this.toggle[_this.name + '_' + t.id] = flg;
            }
        });
    };
    SortTreeGroupComponent.prototype.ngAfterViewInit = function () {
        var self = this;
        var name = '#' + this.name;
        $(name).sortable({
            connectWith: name,
            cancel: '.sortable_toggle',
            placeholder: 'sortable_placeholder',
            update: function (event, ui) {
                var move = {
                    operation: 'move',
                    params: {
                        id: ui.item.data('id'),
                        from: self.parent,
                        to: self.parent,
                        order: ui.item.index()
                    }
                };
                self.service.setMove(move);
            }
        });
        $(name).disableSelection();
    };
    SortTreeGroupComponent.prototype.switchToggle = function (name) {
        this.toggle[name] = !this.toggle[name];
    };
    SortTreeGroupComponent.prototype.trackByTree = function (index, node) {
        return node.id;
    };
    SortTreeGroupComponent.prototype.ngOnDestroy = function () {
        this.subsc.unsubscribe();
        $('#' + this.name).sortable('destroy');
    };
    SortTreeGroupComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'sort-treegroup',
                    template: "<ul id=\"{{ name }}\" [style.display]=\"open ? 'block': 'none'\">\n  <li *ngFor=\"let t of tree; let index = index; trackBy: trackByTree;\" class='sortable_li' [attr.data-id]='t.id' [attr.data-label]='t.label'>\n    <span *ngIf=\"t.children?.length > 0\" class=\"sortable_toggle\" [class.open]=\"toggle[name + '_' + t.id]\" (click)=\"switchToggle(name + '_' + t.id)\"></span>\n    <column-formlabel [col]=\"{}\" [val]=\"t.label\"></column-formlabel>\n    <sort-treegroup *ngIf=\"t.children?.length > 0\" [tree]=\"t.children\" [name]=\"name + '_' + t.id\" [parent]=\"t.id\" [open]=\"toggle[name + '_' + t.id]\"></sort-treegroup>\n  </li>\n</ul>\n"
                }] }
    ];
    /** @nocollapse */
    SortTreeGroupComponent.ctorParameters = function () { return [
        { type: SortTreeService }
    ]; };
    SortTreeGroupComponent.propDecorators = {
        tree: [{ type: Input }],
        name: [{ type: Input }],
        parent: [{ type: Input }],
        open: [{ type: Input }]
    };
    return SortTreeGroupComponent;
}());
export { SortTreeGroupComponent };
//# sourceMappingURL=sort-tree.component.js.map